angular.module('mychart').controller('PharmacyModalCtrl',
    ['_', '$scope', '$stateParams', '$uibModalInstance', 'MyChartService', 'toaster', 'aprgettext', 'pharmacies', 'debounce',
        function (_, $scope, $stateParams, $modalInstance, MyChartService, toaster, gettext, pharmacies, debounce) {
            'use strict';

            $scope.pharmacies = _.cloneDeep(pharmacies) || [];
            $scope.searchPharmaciesParams = {
                Zip: '',
                PhoneNumber: ''
            };

            $scope.pharmacyResults = [];
            $scope.noResults = false;
            
            function ok() {
                $modalInstance.close($scope.pharmacies);
            }

            function cancel() {
                $modalInstance.dismiss('cancel');
            }
           
           function searchPharmacies(zip, phoneNumber) {
                if (!zip) {
                    zip = $scope.searchPharmaciesParams.Zip;
                }
                if (!phoneNumber) {
                    phoneNumber = $scope.searchPharmaciesParams.PhoneNumber;
                }
               
                MyChartService.searchPharmacies(zip, phoneNumber)
                    .then(function (data) {
                        $scope.pharmacyResults = data.plain();
                        $scope.noResults = data.length === 0;
                    });
            }

            function addPharmacy(index, pharmacy) {
                if (_.find($scope.pharmacies, {PharmacyId: pharmacy.PharmacyId})) {
                    toaster.pop('warning', '', gettext('This is already a preferred pharmacy.'));
                } else {
                    $scope.pharmacies.push(pharmacy);
                    $scope.pharmacyResults.splice(index, 1);
                }
            }

            function removePharmacy(index, pharmacy) {
                $scope.pharmacies.splice(index, 1);
                $scope.pharmacyResults.unshift(pharmacy);
                $scope.noResults = false;
            }

            function submitZip() {
                debounce(750, function submitZip() {
                    if ($scope.searchPharmaciesParams.Zip.length > 4) {
                        $scope.searchPharmacies();
                    }
                });
            }

            function submitPhoneNumber (){
                debounce(750, function submitZip() {
                    var tempPhoneNumber = $scope.searchPharmaciesParams.PhoneNumber,
                        value = tempPhoneNumber.toString().trim().replace(/[^0-9]/g, '');

                    if (value.length > 9) {
                        $scope.searchPharmacies(null, value);
                    }
                });
            } 

            $scope.ok = ok;
            $scope.cancel = cancel;
            $scope.searchPharmacies = searchPharmacies;
            $scope.addPharmacy = addPharmacy;
            $scope.submitZip = submitZip;
            $scope.removePharmacy = removePharmacy;
            $scope.submitPhoneNumber = submitPhoneNumber;
        }]);
